import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'FilterTotalIncomeLeft',
    pure: false
})
export class FilterTotalIncomeLeft implements PipeTransform {
    transform(incomes: any[], expenses: any[]): any {

        let sumIncomes = 0,
            sumExpenses = 0;

        incomes.forEach(element => {
            sumIncomes += element.value;
        });

        expenses.forEach(element => {
            sumExpenses += element.value;
        });

        return (sumIncomes - sumExpenses).toLocaleString();

    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/filter.totalincomeleft.ts